import { render } from "./ImageUpload.vue?vue&type=template&id=9311a9e8&scoped=true&ts=true"
import script from "./ImageUpload.vue?vue&type=script&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&lang=ts"

import "./ImageUpload.vue?vue&type=style&index=0&id=9311a9e8&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9311a9e8"]])

export default __exports__